import { render, staticRenderFns } from "./distributionChart.vue?vue&type=template&id=d735cc20&scoped=true"
import script from "./distributionChart.vue?vue&type=script&lang=js"
export * from "./distributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d735cc20",
  null
  
)

export default component.exports